//@flow
import HelloBarStoreClass from './helloBarStoreClass';

export default new HelloBarStoreClass();
